
            <div class="content-wrapper">
                <div class="page-header">
                    <h3 class="page-title" style="cursor: context-menu;">
                        <span class="page-title-icon bg-gradient-success text-white mr-2">
                            <i class="mdi mdi-file-document menu-icon"></i>
                        </span> รายงานการตรวจสอบโดยกลุ่มการตรวจสอบภายใน
                    </h3>
                    <nav aria-label="breadcrumb">
                        <button class="btn btn-inverse-success btn-fw" data-toggle="modal"
                            data-target="#upload" (click)="select_type = 'month'">อัพโหลด</button>
                    </nav>
                    <div class="modal fade" id="upload" tabindex="-1" role="dialog" aria-labelledby="upload"
                        aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header" style="background-color: white;">
                                    <h5 class="modal-title" id="upload">อัพโหลด
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body" style="margin-top: -30px; background-color: white;">
                                    <div class="row" id="type" style="margin-left: 20px;">
                                        <div class="form-check form-check-success">
                                            <label class="form-check-label">
                                                <input type="radio" class="form-check-input" name="optionsRadios"
                                                    id="month" value="month" [(ngModel)]="select_type"
                                                    (change)="onSelect_type()">
                                                ข้อมูลรายเดือน <i class="input-helper"></i></label>
                                        </div>
                                        <div class="form-check form-check-success" style="margin-left: 10px;">
                                            <label class="form-check-label">
                                                <input type="radio" class="form-check-input" name="optionsRadios"
                                                    id="year" value="year" [(ngModel)]="select_type"
                                                    (change)="onSelect_type()">
                                                ข้อมูลรายปี <i class="input-helper"></i></label>
                                        </div>
                                    </div>
                                    <form [formGroup]="yearForm" *ngIf="select_type == 'month'">
                                        <div class="col-12">
                                            <label>ปีงบประมาณ <b style="color: red;" *ngIf="!yearForm.value.year">
                                                    *</b></label>
                                            <select class="form-control form-control-lg" formControlName="year"
                                                required>
                                                <option *ngFor="let year of fiscal_year" value="{{year}}">{{year}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-12">
                                            <label>เดือน <b style="color: red;" *ngIf="!yearForm.value.month">
                                                    *</b></label>
                                            <select class="form-control form-control-lg" formControlName="month"
                                                required>
                                                <option *ngFor="let month of months" value="{{month.th}}">{{month.th}}
                                                </option>
                                            </select>
                                        </div><br>
                                        <div class="col-12">
                                            <label>ชื่อรายงาน <b style="color: red;" *ngIf="!yearForm.value.pdf_name"> *</b></label>
                                            <input class="form-control form-control-lg" type="text" formControlName="pdf_name" required>
                                        </div>
                                        <br>
                                        <div class="col-12">
                                            เลือกไฟล์ <b style="color: red;"> *</b>
                                            <input type="file" class="dropify" id="upload" formControlName="pdf_file"
                                                (change)="onFileSelect($event)" required />

                                        </div>
                                        <br>
                                        <div style="float: right;">
                                            <button type="submit" class="btn btn-gradient-success" data-dismiss="modal"
                                                [disabled]="!yearForm.valid" (click)="onClickSave()">บันทึก</button>
                                            <button type="button" class="btn btn-gradient-light" data-dismiss="modal"
                                                style="margin-left: 10px;" (click)="onClose()">ยกเลิก</button>
                                        </div>

                                    </form>
                                    <form [formGroup]="yearForm" *ngIf="select_type == 'year'">
                                        <div class="col-12">
                                            <label>ปีงบประมาณ <b style="color: red;" *ngIf="!yearForm.value.year">
                                                    *</b></label>
                                            <select class="form-control form-control-lg" formControlName="year"
                                                required>
                                                <option *ngFor="let year of fiscal_year" value="{{year}}">{{year}}
                                                </option>
                                            </select>
                                        </div><br>
                                        <div class="col-12">
                                            <label>ชื่อรายงาน <b style="color: red;" *ngIf="!yearForm.value.pdf_name"> *</b></label>
                                            <input class="form-control form-control-lg" type="text" formControlName="pdf_name" required>
                                        </div>
                                        <br>
                                        <div class="col-12">
                                            เลือกไฟล์ <b style="color: red;"> *</b>
                                            <input type="file" class="dropify" id="upload" formControlName="pdf_file"
                                                (change)="onFileSelect($event)" required />

                                        </div>
                                        <br>
                                        <div style="float: right;">
                                            <button type="submit" class="btn btn-gradient-success" data-dismiss="modal"
                                                [disabled]="!yearForm.valid" (click)="onClickSave()">บันทึก</button>
                                            <button type="button" class="btn btn-gradient-light" data-dismiss="modal"
                                                style="margin-left: 10px;" (click)="onClose()">ยกเลิก</button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-sm-12 grid-margin">
                        <div class="card" style="border-radius: 15px;" *ngIf="displayList">
                            <div class="card-body">
                                <div>
                                    <div class="row" id="viewType"
                                        style="vertical-align: middle;width: fit-content; margin-right: 0px; margin-left: auto;">
                                        <div class="form-check form-check-success">
                                            <label class="form-check-label">
                                                <input type="radio" class="form-check-input" name="month" id="month"
                                                    value="month" [(ngModel)]="view_type" (click)="switchTypeView('month')">
                                                ข้อมูลรายเดือน <i class="input-helper"></i></label>
                                        </div>
                                        <div class="form-check form-check-success" style="margin-left: 10px;">
                                            <label class="form-check-label">
                                                <input type="radio" class="form-check-input" name="year" id="year"
                                                    value="year" [(ngModel)]="view_type" (click)="switchTypeView('year')">
                                                ข้อมูลรายปี <i class="input-helper"></i></label>
                                        </div>
                                    </div>
                                    <div class="row" style="width: fit-content;margin-right: 0px;margin-left: auto; margin-top: 10px;">
                                        <select class="form-control" *ngIf="view_type=='month'"
                                            style="width: auto; height: 40px; margin-top: auto; margin-bottom: auto;margin-right: 0px; margin-left: 20px; "
                                            name="year_select" [(ngModel)]="select.month">
                                            <option value="" [disabled]="true">ค้นหาจากเดือน</option>
                                            <option *ngFor="let month of list_month" value="{{month}}">{{month}}</option>
                                        </select>
                                        <select class="form-control"
                                            style="width: auto; height: 40px; margin-top: auto; margin-bottom: auto;margin-right: 0px; margin-left: 10px; "
                                            name="year_select" [(ngModel)]="select.year">
                                            <option value="" [disabled]="true">ค้นหาจากปีงบประมาณ</option>
                                            <option *ngFor="let year of years" value="{{year}}">{{year}}</option>
                                        </select>
                                        <div style="margin-top:auto; margin-bottom: auto; margin-left: 20px;">
                                            <button class="btn btn-inverse-success" (click)="onClickSearch()">ค้นหา</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-striped" *ngIf="view_type=='month' && search_month" style="cursor:context-menu;">
                                        <thead>
                                            <tr>
                                                <th class="text-center tab-10"> ปีงบประมาณ </th>
                                                <th class="text-center tab-20"> เดือน </th>
                                                <th class="text-center tab-25"> ชื่อไฟล์ </th>
                                                <th class="text-center tab-20"> วันที่อัพโหลด</th>
                                                <th class="text-center tab-30"> </th>
                                            </tr>
                                        </thead>
                                        <tbody id="data_month">
                                            <tr *ngFor="let data of search_month| paginate : {
                                                    itemsPerPage: tableSize,
                                                    currentPage: page,
                                                    totalItems: count
                                                  };" >
                                                <td class="text-center tab-10">{{data.year}}</td>
                                                <td class="text-center tab-20">{{data.month}}</td>
                                                <td class="tab-25" title="{{data.pdf_name}}">
                                                    {{data.pdf_name}}</td>
                                                <td class="text-center tab-20">{{data.date_report}}</td>
                                                <td class="tab-30">
                                                    <button type="button"
                                                        class="btn btn-inverse-success btn-icon btn-sm" style="cursor: pointer;"
                                                        (click)="onClickView(data.pdf_file, data.pdf_name)">
                                                        <i class="mdi mdi-eye"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-inverse-info btn-icon btn-sm"
                                                        style="margin-left: 10px;cursor: pointer;"
                                                        (click)="onClickDownload(data.pdf_file, data.pdf_name)">
                                                        <i class="mdi mdi-download"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-inverse-danger btn-icon btn-sm"
                                                        style="margin-left: 10px;cursor: pointer;" (click)="onClickDelete(data)">
                                                        <i class="mdi mdi-delete-forever"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped" *ngIf="view_type=='year' && search_year" style="cursor:context-menu;">
                                        <thead>
                                            <tr>
                                                <th class="text-center tab-10"> ปีงบประมาณ </th>
                                                <th class="text-center tab-25"> ชื่อไฟล์ </th>
                                                <th class="text-center tab-20"> วันที่อัพโหลด</th>
                                                <th class="text-center tab-30"> </th>
                                            </tr>
                                        </thead>
                                        <tbody id="data_month">
                                            <tr *ngFor="let data of search_year| paginate : {
                                                    itemsPerPage: tableSizeY,
                                                    currentPage: pageY,
                                                    totalItems: countY
                                                  };">
                                                <td class="text-center tab-10">{{data.year}}</td>
                                                <td class="tab-25" title="{{data.pdf_name}}">
                                                    {{data.pdf_name}}</td>
                                                <td class="text-center tab-20">{{data.date_report}}</td>
                                                <td class="tab-30">
                                                    <button type="button"
                                                        class="btn btn-inverse-success btn-icon btn-sm" style="cursor: pointer;"
                                                        (click)="onClickView(data.pdf_file, data.pdf_name)">
                                                        <i class="mdi mdi-eye"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-inverse-info btn-icon btn-sm"
                                                        style="margin-left: 10px;cursor: pointer;"
                                                        (click)="onClickDownload(data.pdf_file, data.pdf_name)">
                                                        <i class="mdi mdi-download"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-inverse-danger btn-icon btn-sm"
                                                        style="margin-left: 10px;cursor: pointer;" (click)="onClickDelete(data)">
                                                        <i class="mdi mdi-delete-forever"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="text-center" *ngIf="!search_year || !search_month" style="margin-top: 20px;">
                                    <h3 style="color: lightgrey;cursor:context-menu;">ไม่พบรายการที่ค้นหา</h3>
                                </div>
                            </div>
                            <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า" nextLabel="ถัดไป" *ngIf="view_type=='month' && search_month"
                                (pageChange)="onTableDataChange($event)" style="text-align: center;">
                            </pagination-controls>
                            <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า" nextLabel="ถัดไป" *ngIf="view_type=='year' && search_year"
                                (pageChange)="onTableDataChangeY($event)" style="text-align: center;">
                            </pagination-controls>
                        </div>
                        <div class="card" style="border-radius: 15px;" *ngIf="displayPdf">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6 text-left" style="cursor:context-menu;">{{pdfName}}</div>
                                    <div class="col-6 text-right"><button type="button" class="btn btn-outline-success"
                                            (click)="onClickClose()">ย้อนกลับ</button></div>
                                </div>
                                <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>